/**
 * As constantes que o registry e os embrulhos COMPARTILHAM — spec-010, [T017].
 *
 * Elas moram fora do `registry.js` por um motivo de grafo: o registry aponta
 * para os embrulhos por `() => import(...)` (é o que mantém os cartões fora do
 * bundle inicial), e um embrulho importando o registry de volta criaria um
 * ciclo — que o webpack resolve com um objeto pela metade, em silêncio.
 *
 * Uma chave redigitada não quebra nada visivelmente: o `tool_result` chega sem
 * dono e o cartão simplesmente não aparece. Por isso as três strings existem
 * uma vez só, e `registry.unit.js` as compara com os arquivos das tools no
 * backend.
 */

/** As chaves `<modulo>/<cartao>` do contrato (`contracts/ui-components.md`). */
export const CHAVES = {
  ALERTAS: 'atendimento/alertas-atrasados',
  RECENTES: 'atendimento/recentes',
  MENSAGENS: 'atendimento/mensagens-do-cliente',
}

/**
 * Os nomes das tools no backend. O front não importa o backend; os nomes vivem
 * literais aqui e a suíte os confere contra os arquivos de lá.
 */
export const TOOL_ALERTAS = 'list_alertas_atrasados'
export const TOOL_CONVERSAS_DA_CAIXA = 'list_conversas_atendimento'
export const TOOL_MENSAGENS_DO_CLIENTE = 'list_atendimentos_recentes'

/**
 * A tela do atendimento — aba do CRM (`modules/crm/routes.js`), gateada por
 * `FEATURES.ATENDIMENTO`. O `navegar` da spec-001 só alcança o destino `crm`
 * (a raiz do módulo); a conversa selecionada precisa da aba, então a rota é
 * empurrada pelo nome.
 */
export const ROTA_DO_ATENDIMENTO = 'crm.atendimento'
